import React from "react";

/** Heetch Pro flat card — dark surface, no shadows. */
export function GlassCard({ children, className = "", ...rest }) {
  return (
    <div
      className={`bg-[var(--surface)] border border-[var(--border)] rounded-xl ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function SectionTitle({ icon: Icon, children, right }) {
  return (
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2 text-[var(--text)] font-display font-semibold text-lg">
        {Icon && <Icon className="w-4 h-4 text-emerald-400" strokeWidth={1.8} />}
        {children}
      </div>
      {right}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle }) {
  return (
    <div className="text-center py-10 text-zinc-500">
      {Icon && <Icon className="w-7 h-7 mx-auto mb-2 opacity-40" />}
      <div className="font-semibold text-[var(--text)]">{title}</div>
      {subtitle && <div className="text-xs mt-1">{subtitle}</div>}
    </div>
  );
}

export function StatTile({ label, value, sub }) {
  return (
    <GlassCard className="p-4">
      <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500">{label}</div>
      <div className="font-display text-3xl font-semibold text-[var(--text)] mt-2 tabular-nums leading-none tracking-tight">{value}</div>
      {sub && <div className="text-[11px] text-zinc-500 mt-1.5">{sub}</div>}
    </GlassCard>
  );
}

export function PillButton({ children, onClick, variant = "default", disabled = false, testId, className = "" }) {
  const map = {
    default: "border border-[var(--border)] text-zinc-300 hover:bg-emerald-500 hover:text-white hover:border-emerald-500",
    primary: "bg-emerald-500 text-white hover:bg-emerald-600 border border-emerald-500",
    danger: "border border-rose-500/50 text-rose-300 hover:bg-rose-600 hover:text-white hover:border-rose-600",
    success: "border border-emerald-500/50 text-emerald-300 hover:bg-emerald-600 hover:text-white hover:border-emerald-500",
    ghost: "text-zinc-400 hover:text-[var(--text)] hover:bg-[var(--surface-alt)]",
  };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={`rounded-full px-3.5 h-9 text-xs font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${map[variant]} ${className}`}
    >
      {children}
    </button>
  );
}
